<template>
  <mp-box
    position="relative"
    :padding-right="!isToggle ? '4' : '0px'"
    background-color="background"
    transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
  >
    <mp-box
      position="relative"
      background-color="background"
      transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
    >
      <mp-box
        id="section-sidebar-child"
        as="section"
        data-id="sidebar-child"
        max-width="12.75rem"
        :width="isToggle ? '12.75rem' : '0'"
        height="calc(100vh - 60px)"
        padding-y="2"
        :padding-x="isToggle ? '2' : '2'"
        margin-left="60px"
        :cursor="isToggle ? 'default' : 'pointer'"
        :background-color="!isToggle && isHovered ? 'ash.100' : 'background'"
        transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
        :border-right="isToggle ? '0px' : '1px'"
        border-color="gray.100"
        :display="['block']"
        z-index="1"
        @mouseenter="handleMouseEnter()"
        @mouseleave="handleMouseLeave()"
        @click.self="handleToggleBlock"
      >
        <mp-box
          max-height="calc(100vh - 90px - 52px)"
          max-width="188px"
          width="inherit"
          overflow-y="auto"
          overflow-x="hidden"
        >
          <mp-text
            text-transform="uppercase"
            white-space="nowrap"
            font-size="sm"
            font-weight="semibold"
            letter-spacing="2px"
            color="blue.400"
            mt="3"
            mb="1"
            padding="2"
          >
            {{ currentPage }}
          </mp-text>

          <mp-accordion allow-toggle>
            <mp-box
              v-for="(submenu, index) in submenuFiltered"
              :key="submenu.name"
            >
              <!-- Submenu without child -->
              <mp-box
                v-if="submenu.child.length < 1 || flaggingChecker(submenu)"
              >
                <mp-flex direction="column">
                  <mp-pseudo-box
                    flex="1"
                    role="group"
                    border-radius="md"
                    padding="2"
                    :background-color="
                      submenu.isActive ? 'blue.100' : 'transparent'
                    "
                    transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                    :_hover="{
                      color: 'blue.400',
                      backgroundColor: 'blue.100',
                      cursor: 'pointer',
                    }"
                    @click="
                      onSubmenuClick(submenu, index, submenu.child.length > 0)
                    "
                  >
                    <mp-stack
                      direction="row"
                      align="center"
                      justify="space-between"
                      gap="2"
                    >
                      <mp-text
                        white-space="normal"
                        word-break="break-word"
                        flex="1"
                        min-width="0"
                        :color="submenu.isActive ? 'blue.400' : 'dark'"
                        :font-weight="submenu.isActive ? 'semibold' : 'regular'"
                      >
                        {{ submenu.name }}
                      </mp-text>
                      <mp-badge
                        v-if="submenu.name === 'Chatbot AI' || submenu.isNew"
                        variant="solid"
                        variant-color="red"
                        size="sm"
                        flex-shrink="0"
                      >
                        NEW
                      </mp-badge>
                    </mp-stack>
                  </mp-pseudo-box>
                </mp-flex>
              </mp-box>
              <!-- Submenu that have childs -->
              <mp-box v-else>
                <mp-accordion-item
                  border-bottom-width="0px!important"
                  :is-open="accordionIdx === index"
                  @change="
                    onSubmenuClick(submenu, index, submenu.child.length > 0)
                  "
                >
                  <mp-accordion-header
                    gap="1"
                    padding="2"
                    border-radius="md"
                    :background-color="
                      submenu.isActive ? 'blue.100' : 'transparent'
                    "
                    transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                    :_hover="{
                      color: 'blue.400',
                      backgroundColor: submenu.isActive
                        ? 'blue.100'
                        : 'blue.100',
                      cursor: 'pointer',
                    }"
                  >
                    <mp-flex justify-content="space-between" width="100%">
                      <mp-box>
                        <mp-flex direction="column">
                          <mp-pseudo-box flex="1" border-radius="sm">
                            <mp-stack direction="row" align="center">
                              <mp-text
                                white-space="nowrap"
                                :color="submenu.isActive ? 'blue.400' : 'dark'"
                                :font-weight="
                                  submenu.isActive ? 'semibold' : 'regular'
                                "
                              >
                                {{ submenu.name }}
                              </mp-text>
                            </mp-stack>
                          </mp-pseudo-box>
                        </mp-flex>
                      </mp-box>
                      <mp-accordion-icon />
                    </mp-flex>
                  </mp-accordion-header>
                  <mp-accordion-panel padding-y="0">
                    <mp-box
                      v-for="child in filteredSubmenuChild(submenu.child)"
                      :id="`${submenu.name}-${child.title}`"
                      :key="child.code"
                    >
                      <mp-flex
                        v-if="child.status"
                        direction="column"
                        @click="onSubmenuChildClick(child)"
                      >
                        <mp-pseudo-box
                          flex="1"
                          role="group"
                          border-radius="md"
                          padding-left="4"
                          padding-y="2"
                          color="dark"
                          transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                          :_hover="{
                            color: 'blue.400',
                            cursor: 'pointer',
                          }"
                        >
                          <mp-stack
                            direction="row"
                            align="center"
                            justify="space-between"
                          >
                            <mp-text
                              white-space="nowrap"
                              :font-weight="child.isActive ? 'semibold' : ''"
                              :color="child.isActive ? 'dark' : 'gray.600'"
                            >
                              {{ child.title }}
                            </mp-text>
                            <mp-badge
                              v-if="child.isNew"
                              variant="solid"
                              variant-color="red"
                              size="sm"
                            >
                              NEW
                            </mp-badge>
                          </mp-stack>
                        </mp-pseudo-box>
                      </mp-flex>
                    </mp-box>
                  </mp-accordion-panel>
                </mp-accordion-item>
              </mp-box>
            </mp-box>
          </mp-accordion>

          <!-- // BUTTON COLLAPSE SIDEBAR CHILD -->
          <mp-flex
            v-if="isToggle"
            gap="2"
            background-color="background"
            flex-direction="row"
            justify-content="flex-end"
            align-items="center"
            position="fixed"
            bottom="0"
            :left="isStacked ? '12.75rem' : '60px'"
            padding="2"
            width="inherit"
          >
            <mp-tooltip
              position="right"
              :show-delay="200"
              label="Click to collapse or shortcut [shift] + [c]"
              use-portal
            >
              <mp-pseudo-box
                role="group"
                border-radius="sm"
                transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                padding-x="2.5"
                padding-y="2"
                outline="none !important"
                :_hover="{
                  backgroundColor: 'blue.100',
                  color: 'blue.400',
                  cursor: 'pointer',
                }"
                @click="handleToggle"
              >
                <mp-stack direction="row" align="center">
                  <mp-icon name="chevrons-previous" size="sm" />
                </mp-stack>
              </mp-pseudo-box>
            </mp-tooltip>
          </mp-flex>
        </mp-box>
      </mp-box>
    </mp-box>
    <mp-box
      position="fixed"
      width="inherit"
      bottom="8px"
      :left="isStacked ? '14.50rem' : '76px'"
      z-index="1"
      :opacity="!isToggle ? '1' : '0'"
      transition-property="all"
      transition-duration="300ms"
      :transition-delay="!isToggle ? '300ms' : ''"
      transition-timing-function="cubic-bezier(.4,0,.2,1)"
      :transform="!isToggle ? 'translateX(0px);' : 'translateX(-8px);'"
    >
      <mp-tooltip
        position="right"
        :show-delay="200"
        label="Click to expand or shortcut [shift] + [c]"
        use-portal
      >
        <mp-pseudo-box
          display="flex"
          :width="isHovered ? '36px' : '24px'"
          height="36px"
          background-color="white"
          border="1px"
          border-color="gray.100"
          border-top-right-radius="full"
          border-bottom-right-radius="full"
          align-items="center"
          justify-content="flex-end"
          padding-right="1"
          padding-left="1"
          box-shadow="rgb(0 0 0 / 14%) 3px 0px 4px, rgb(0 0 0 / 12%) 0px 0px 2px"
          transition="all .3s cubic-bezier(.4,0,.2,1)"
          :_hover="{
            width: '36px',
            cursor: 'pointer',
          }"
          @mouseenter="handleMouseEnter()"
          @mouseleave="handleMouseLeave()"
          @click="handleToggle"
        >
          <mp-icon name="chevrons-right" size="sm" />
        </mp-pseudo-box>
      </mp-tooltip>
    </mp-box>
  </mp-box>
</template>

<script>
import { mapState } from 'vuex'
import { PackageName } from '~/store/package'
import { EventBus } from '@/plugins/event-bus'
import { PermissionName } from '~/store/usman'
import globalMixin from '~/assets/mixins/global/globalMixin'
import permissionMixin from '~/assets/mixins/permissions/permissionMixin'

export default {
  name: 'SidebarChild',
  mixins: [globalMixin, permissionMixin],
  props: {
    menus: {
      type: [Array, Object],
      default: () => [],
    },
    submenus: {
      type: [Array, Object],
      default: () => [],
    },
    isStacked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isToggle: true,
      isHovered: false,
      isActive: true,
      accordionIdx: -1,
      chatbotRolloutPackage: false,
    }
  },
  computed: {
    ...mapState('package', ['isUsePackageCode', 'packageCodes']),
    ...mapState('layouts', ['appConfig']),
    ...mapState('usman', [
      'isUseUsmanPermissions',
      'isLoading',
      'isInitialized',
    ]),
    billingInfo() {
      return this.$store.getters['preferences/getBillingInfo']
    },
    aireneInfo() {
      return this.$store.getters['organization/getSmartAssistInfo']
    },
    isShowQontakCRMMenu() {
      const isIncludesSpecialPackage = this.packageCodes.includes(
        'CP-QONTAKCRM-2024-0006'
      )
      const isFollowingUsecasePackageRules =
        this.isUsePackageCode && isIncludesSpecialPackage
      return !this.isUsePackageCode || isFollowingUsecasePackageRules
    },
    isShowChatbotAIFinanceMenu() {
      if (this.isUsePackageCode) {
        return this.packageCodes.includes('CP-QONTAKCHAT-2025-0004')
      }
      return true
    },
    /**
     * NOTE:
     * Will delete after stable release
     */
    // isShowMenuSettingIntegrationCall() {
    //   // Calls Packages
    //   const CP_QC_0004 = this.$store.getters['package/isEnableBillingPackage'](
    //     PackageName['CP-QONTAKCHAT-2025-0004']
    //   )
    //   const CP_QC_0013 = this.$store.getters['package/isEnableBillingPackage'](
    //     PackageName['CP-QONTAKCHAT-2025-0013']
    //   )
    //   const CP_QC_0014 = this.$store.getters['package/isEnableBillingPackage'](
    //     PackageName['CP-QONTAKCHAT-2025-0014']
    //   )
    //   const CP_QC_0015 = this.$store.getters['package/isEnableBillingPackage'](
    //     PackageName['CP-QONTAKCHAT-2025-0015']
    //   )
    //   return CP_QC_0004 && (CP_QC_0013 || CP_QC_0014 || CP_QC_0015)
    // },
    isCallPackagePassed() {
      const CP_QC_0004 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0004']
      )
      const CP_QC_0013 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0013']
      )
      const CP_QC_0014 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0014']
      )
      const CP_QC_0015 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0015']
      )
      return CP_QC_0004 && (CP_QC_0013 || CP_QC_0014 || CP_QC_0015)
    },
    isCallPilotProjectPassed() {
      const isCustomEnablementEnabled =
        this.appConfig?.wa_call?.pilot_project?.enabled ?? false
      const TARGET_COMPANY_ID =
        this.appConfig?.wa_call?.pilot_project?.company_ids ?? []
      const isCompanyIdMatch =
        (this.credentials?.[0]?.company_id &&
          TARGET_COMPANY_ID.includes(this.credentials?.[0]?.company_id)) ||
        false
      if (!isCustomEnablementEnabled) return true
      return isCustomEnablementEnabled && isCompanyIdMatch
    },
    isShowCallMenuValidation() {
      /**
       * NOTE:
       * Only handle for non Qontak One, because Qontak One user will handled by bifrost team,
       * since we are using Unified Sidebar for Qontak One user
       */
      return this.isCallPackagePassed && this.isCallPilotProjectPassed
    },
    permissionsInfo() {
      return this.$store.getters['organization/getPermissions']
    },
    isShowEmailCampaignMenuChild() {
      if (this.$store.state.package.isUsePackageCode) {
        return this.packageCodes.includes('CP-QONTAKCHAT-2025-0006')
      } else {
        return this.permissionsInfo.email_campaign.enabled
      }
    },
    chatbotSubs() {
      return this.$store.getters['preferences/getChatbotSubs']
    },
    chatbotPreferences() {
      return this.$store.getters['preferences/getChatbotPreferences']
    },
    billingPostpaidStatus() {
      // if billing status === postpaid
      return (
        this.billingInfo.billing_enabled === true &&
        this.billingInfo.payment_type === 'prepaid' &&
        !this.billingInfo.is_trial
      )
    },
    isEnableDashboardCustomerInsight() {
      if (this.$store.state.package.isUsePackageCode) {
        return this.$store.getters['package/isEnableBillingPackage'](
          PackageName['CP-QONTAKCHAT-2025-0020']
        )
      } else {
        return this.permissionsInfo?.customer_insights
      }
    },
    isShowSlaOverviewMenu() {
      if (this.$store.state.package.isUsePackageCode) {
        return this.$store.getters['package/isEnableBillingPackage'](
          PackageName['QONTAKCHAT-SLA']
        )
      } else {
        return this.billingInfo?.sla_dashboard_enabled
      }
    },
    isShowSlaManagementMenu() {
      if (this.$store.state.package.isUsePackageCode) {
        return this.$store.getters['package/isEnableBillingPackage'](
          PackageName['QONTAKCHAT-SLA']
        )
      } else {
        return this.billingInfo?.sla_dashboard_enabled
      }
    },
    isShowSurveySettingMenu() {
      if (this.$store.state.package.isUsePackageCode) {
        return this.$store.getters['package/isEnableBillingPackage'](
          PackageName['CP-QONTAKCHAT-2025-0002']
        )
      } else {
        return true
      }
    },
    isShowMekariAireneSettingMenu() {
      return (
        this.permissionsInfo.chatbot_tone_of_voice ||
        this.aireneInfo ||
        this.chatbotRolloutPackage ||
        (this.$store.state.package.isUsePackageCode &&
          this.chatbotSubs.ai_paraphrase_enabled)
      )
    },
    isHideImportExportMenu() {
      return !this.isAdmin() && !this.isOwner()
    },
    billingAskAireneInfo() {
      return this.billingInfo.is_airene_enabled
    },
    isEnableScorecardUsman() {
      const access = this.canAccessScorecard
      // If null, use legacy logic
      if (access === null) {
        return !this.isAgent() && !this.isMember()
      }
      return access
    },
    isShowGoogleMyBusiness() {
      // Show if feature flag is enabled OR user has settings_integrations_view permission
      const hasFeatureFlag = this.permissionsInfo.google_my_business
      const hasIntegrationsPermission =
        this.isInitialized &&
        this.isUseUsmanPermissions &&
        this.$store.getters['usman/isHasPermission'](
          'settings_integrations_view'
        )

      return hasFeatureFlag || hasIntegrationsPermission
    },
    isIntegrationCallMasterFlagEnabled() {
      return this.appConfig?.wa_call?.integration_call_menu?.enabled ?? false
    },
    isSettingCallMasterFlagEnabled() {
      return this.appConfig?.wa_call?.setting_call_menu?.enabled ?? false
    },
    isMetaAdAccountMenuShown() {
      return (
        this.appConfig?.meta_ad_account?.meta_ad_account_menu?.enabled ?? false
      )
    },
    submenuFiltered() {
      // Hide submenus until USMAN is initialized or while loading
      if (
        !this.isInitialized ||
        (this.isUseUsmanPermissions && this.isLoading)
      ) {
        return []
      }

      let submenu = this.submenus

      if (!this.isEnableDashboardCustomerInsight) {
        submenu = submenu.filter((menu) => menu.name !== 'Customer insights')
      }
      if (!this.isShowSlaOverviewMenu) {
        submenu = submenu.filter((menu) => menu.name !== 'SLA overview')
      }
      if (!this.isShowQontakCRMMenu) {
        submenu = submenu.filter((menu) => menu.name !== 'Qontak CRM')
      }
      if (!this.isShowChatbotAIFinanceMenu) {
        submenu = submenu.filter((menu) => menu.name !== 'Chatbot AI')
      }
      if (!this.isShowMekariAireneSettingMenu) {
        submenu = submenu.filter((menu) => menu.name !== 'Mekari Airene')
      }
      if (
        !(
          this.permissionsInfo.chatbot_score_card ||
          this.chatbotSubs.scorecard_chatbot_subscription
        )
      ) {
        submenu = submenu.filter((menu) => menu.name !== 'Scorecard')
      }
      // Scorecard via Usman Permission
      if (!this.isEnableScorecardUsman)
        submenu = submenu.filter((menu) => menu.name !== 'Scorecard')

      if (!this.billingPostpaidStatus || this.canAccessSubscriptions)
        submenu = submenu.filter((menu) => menu.name !== 'Subscription')

      if (!this.isShowSlaManagementMenu)
        submenu = submenu.filter((menu) => menu.name !== 'SLA management')

      if (!this.isShowSurveySettingMenu)
        submenu = submenu.filter((menu) => menu.name !== 'Customer survey')

      if (this.isHideImportExportMenu)
        submenu = submenu.filter(
          (menu) => menu.link !== '/settings/import-export'
        )

      if (!this.billingAskAireneInfo)
        submenu = submenu.filter((menu) => menu.name !== 'Ask Airene')

      if (!this.permissionsInfo.livechat_channel_integration)
        submenu = submenu.filter((menu) => menu.name !== 'Live Chat')

      submenu = submenu.filter((menu) => menu.name !== 'Call activity')

      if (
        !this.isSettingCallMasterFlagEnabled ||
        !this.isShowCallMenuValidation
      )
        submenu = submenu.filter((menu) => menu.name !== 'Call')

      if (
        !this.isIntegrationCallMasterFlagEnabled ||
        !this.isShowCallMenuValidation
      )
        submenu = submenu.filter((menu) => menu.link !== '/integrations/call')

      if (!this.isShowGoogleMyBusiness)
        submenu = submenu.filter((menu) => menu.name !== 'Google My Business')

      if (!this.isMetaAdAccountMenuShown)
        submenu = submenu.filter(
          (menu) => menu.link !== '/integrations/meta_ads_manager'
        )

      return submenu
    },
    currentPage() {
      const [firstName] = this.$route.name.split('-')
      const selectedMenu = this.menus.filter((menu) => menu.slug === firstName)
      return selectedMenu.length > 0 ? selectedMenu[0]?.name : firstName
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
    this.setDefaultSubmenuOpen()
    EventBus.$on(
      'update-chatbot-rollout-package',
      this.handleUpdateChatbotRolloutPackage
    )
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
    EventBus.$off(
      'update-chatbot-rollout-package',
      this.handleUpdateChatbotRolloutPackage
    )
  },
  methods: {
    filteredSubmenuChild(submenuChild) {
      if (
        !this.isInitialized ||
        (this.isUseUsmanPermissions && this.isLoading)
      ) {
        return []
      }
      if (this.isShowEmailCampaignMenuChild) {
        return submenuChild.map((child) =>
          child.slug === 'integrations/email/campaign/subdomain'
            ? { ...child, status: true }
            : child
        )
      }
      return submenuChild
    },
    handleUpdateChatbotRolloutPackage(value) {
      this.chatbotRolloutPackage = value
    },
    handleToggle() {
      this.isToggle = !this.isToggle
      this.$emit('toggle', this.isToggle)
    },
    handleToggleBlock() {
      if (!this.isToggle) this.isToggle = true
      this.$emit('toggle', this.isToggle)
    },
    handleMouseEnter() {
      this.isHovered = true
    },
    handleMouseLeave() {
      this.isHovered = false
    },
    handleKeydown(e) {
      const SHIFTKEY = e.shiftKey
      const KEYCODE_C = e.keyCode === 67
      if (SHIFTKEY && KEYCODE_C) {
        this.handleToggle()
      }
    },
    submenuIsOpened(submenu) {
      let isOpen = false
      submenu.child.forEach((child) => {
        if (child.isActive) isOpen = true
      })
      return isOpen
    },
    onSubmenuClick(submenu, index, hasChild) {
      if (index === this.accordionIdx && hasChild) index = -1
      this.accordionIdx = index
      if (submenu.isTracked) {
        setTimeout(() => {
          this.storeMixpanelMetric(`Broadcast Report ${submenu.title} Page`, {
            Role: this.$auth.user.role,
            'User ID': this.$auth.user.id,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
          })
        }, 500)
      }
      if (!hasChild || this.flaggingChecker(submenu)) {
        if (this.isNuxt3Link(submenu.link)) {
          window.location.href = submenu.link
        } else {
          this.$router.push(submenu.link)
        }
      }
    },
    accordionOpenedCheck(index, hasChild) {
      return index === this.accordionIdx && hasChild
    },
    setDefaultSubmenuOpen() {
      const activeSubmenu = this.submenus.filter((submenu) => {
        return submenu.isActive
      })
      if (activeSubmenu.length > 0) this.accordionIdx = activeSubmenu[0].index
    },
    onSubmenuChildClick(child) {
      if (child.isTracked) {
        setTimeout(() => {
          this.storeMixpanelMetric(`Broadcast Report ${child.title} Page`, {
            Role: this.$auth.user.role,
            'User ID': this.$auth.user.id,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
          })
        }, 1000)
      }
      if (this.isNuxt3Link(child.link)) {
        window.location.href = child.link
      } else {
        this.$router.push(`/${child.slug}`)
      }
    },
    flaggingChecker(submenu) {
      if (
        submenu.id === 'integrations-email' &&
        !this.isShowEmailCampaignMenuChild
      ) {
        const statusChildren = submenu.child.filter((child) => child.status)
        if (statusChildren.length === 1) return true
        return false
      }
      if (submenu.id !== 'reports-agent_performance') return false
      const scorecardSubsChecker =
        this.permissionsInfo.chatbot_score_card ||
        this.chatbotSubs.scorecard_chatbot_subscription
      const qualityScoringSubsChecker =
        this.permissionsInfo.quality_scoring_report ||
        this.chatbotPreferences.global_sqs_report
      return !(
        scorecardSubsChecker &&
        qualityScoringSubsChecker &&
        (!this.isUseUsmanPermissions ||
          (this.isUseUsmanPermissions &&
            this.$store.getters['usman/isHasPermission'](
              PermissionName.settings_scorecard_view
            )))
      )
    },
    isNuxt3Link(link) {
      const nuxt3Links = this.appConfig?.v2_feature_links || []
      return nuxt3Links.includes(link)
    },
  },
}
</script>
